module.exports = __webpack_public_path__ + "static/img/console_finance_report.852c7f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/console_finance_report.png
// module id = 1aqh
// module chunks = 8